import React from 'react'
import PropTypes from 'prop-types'
import './FilterSidebarLayout.scss'

class FilterSidebarLayout extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      shownFilterIdx: 0
    }
  }

  render () {
    const { filterOptions, onSelect } = this.props

    const shownFilter = filterOptions[this.state.shownFilterIdx]

    return (
      <div className='FilterSidebarLayout'>
        <div className='FilterSidebarLayout__sidebar'>
          <ul>
            {filterOptions.map((filter, idx) => (
              <li
                key={idx}
                onClick={() => {
                  this.setState({ shownFilterIdx: idx })
                }}
                className={`${
                  filter.label === shownFilter.label ? 'active' : ''
                }`}
              >
                {filter.label}
              </li>
            ))}
          </ul>
        </div>
        <div className='FilterSidebarLayout__filters'>
          <ul>
            <li
              key={0}
              onClick={() => {
                onSelect({ parent: shownFilter.value, child: 'all' })
              }}
              className={`${shownFilter.isAllSelected ? 'active' : ''}`}
            >
              All
            </li>
            {shownFilter.subFilters.map((subFilter, idx) => {
              return (
                <li
                  className={`${subFilter.active ? 'active' : ''}`}
                  key={idx + 1}
                  onClick={() => {
                    onSelect({
                      parent: shownFilter.value,
                      child: subFilter.value
                    })
                  }}
                >
                  {subFilter.label}
                </li>
              )
            })}
          </ul>
        </div>
      </div>
    )
  }
}

FilterSidebarLayout.defaultProps = {
  filterOptions: []
}

FilterSidebarLayout.propTypes = {
  filterOptions: PropTypes.array.isRequired,
  onSelect: PropTypes.func
}

export default FilterSidebarLayout
